import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Nav, NavItem, NavLink } from 'reactstrap';

function ListItem(props) {
  const isSelected = props.value === props.val || (props.val === 0 && props.value === '');

  return (
    <NavItem
      active={isSelected}
      onClick={e => {
        props.onChange(props.val);
      }}
    >
      <NavLink className={props.linkClassName} href="#" active={isSelected}>
        {props.children}
      </NavLink>
    </NavItem>
  );
}

class BathFilter extends Component {
  static contextTypes = {
    theme: PropTypes.object
  };

  render() {
    const BS = this.context.theme;
    var { input } = this.props;
    const listItemProps = {
      ...input,
      linkClassName: `${BS.pt1} ${BS.pb1}`
    };

    return (
      <div>
        <Nav horizontal="space-between" className={BS.navSelect}>
          <ListItem val="" {...listItemProps}>
            Any
          </ListItem>
          <ListItem val={1} {...listItemProps}>
            1+
          </ListItem>
          <ListItem val={2} {...listItemProps}>
            2+
          </ListItem>
          <ListItem val={3} {...listItemProps}>
            3+
          </ListItem>
          <ListItem val={4} {...listItemProps}>
            4+
          </ListItem>
        </Nav>
      </div>
    );
  }
}

export default BathFilter;



// WEBPACK FOOTER //
// ./src/components/form/filter/bath-filter.js